export const CART_IMAGE_SIZE = {
  base: '6rem',
  lg: '10rem',
}